import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { myJobs } from "../../Constant";

function Covid() {
    return (
        <>
            <Header />
            <section
                className="servcies py-10"
                style={{ backgroundImage: `url(${myJobs})` }}
            >
                <div className="container hero supplement ">
                    <div className="row">
                        <div className="col-md-6 py-10">
                            <h1 className="white">COVID Prevention SOP's</h1>
                            <p className="white">
                                An ounce of prevention is worth a pound of cure.
                                Follow the recommended sops for your and your
                                loved ones’ safety.{" "}
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                </div>
            </section>

            <section>
                <div
                    className="container"
                    // style="padding:40px;"
                >
                    <div className="row ">
                        <div className="col-md-12">
                            <div className="contact-box border-right">
                                <h4>Wear a mask.Save lives</h4>
                                <p>To prevent the spread of COVID-19:</p>
                                <ul>
                                    <li>
                                        Maintain a safe distance from others (at
                                        least 1 metre), even if they don’t
                                        appear to be sick.
                                    </li>
                                    <li>
                                        Wear a mask in public, especially
                                        indoors or when physical distancing is
                                        not possible.
                                    </li>
                                    <li>
                                        Choose open, well-ventilated spaces over
                                        closed ones. Open a window if indoors.
                                    </li>
                                    <li>
                                        Clean your hands often. Use soap and
                                        water, or an alcohol-based hand rub.
                                    </li>
                                    <li>
                                        Get vaccinated when it’s your turn.
                                        Follow local guidance about vaccination.
                                    </li>
                                    <li>
                                        Cover your nose and mouth with your bent
                                        elbow or a tissue when you cough or
                                        sneeze.
                                    </li>
                                    <li>Stay home if you feel unwell.</li>
                                </ul>
                                <p>
                                    If you have a fever, cough and difficulty
                                    breathing, seek medical attention. Call in
                                    advance so your healthcare provider can
                                    direct you to the right health facility.
                                    This protects you, and prevents the spread
                                    of viruses and other infections.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Covid;
